export enum DeviceScreenSizes {
  Mobile = 320,
  MobileMid = 544,
  Tablet = 768,
  Desktop = 1025,
  Widescreen = 1440,
}
